import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Basepage, { BasePageState } from '../Basepage';
import MolLink from '../Basepage/parts/Menu/MolLink';

import AdressList, { AddressListEntry } from './SubPages/AdressList';
import AddressEdit from './SubPages/AddressEdit';
import { SelectData } from '../../elements/LabelImput';

import {
  AdressComponnentProp,
  getEmptyAddressProp,
} from '../../elements/AdressComponnent';

import './index.scss';
import { translateAdressApiToModelExtern } from '../Checkout_VR';
import OrdersList, { OrdersListModel } from './SubPages/OrdersList';
import OrderInfo from './SubPages/OrderInfo';
import OpenList from './SubPages/OpenList';
import SchippingList, { SchippingListModel } from './SubPages/SchippingList';
import SchippingDratails from './SubPages/SchippingDratails';
import OrderList from './SubPages/OrderList';
import OrderInfo_mol from './SubPages/OrderInfo_mol';
import Settings from './SubPages/Settings';
import ReadyToSend from './SubPages/ReadyToSend';
import Finance from './SubPages/Finance';
import Rechnungen from './SubPages/Rechnungen';
import Zahlungen from './SubPages/Zahlungen';
import Umsatze from './SubPages/Umsatze';
import Saldoauszug from './SubPages/Saldoauszug';

interface KontoState extends BasePageState {}
interface KontoModel {
  orders: OrdersListModel[];
  shipping: SchippingListModel[];
  addresse: AddressListEntry[];
  countrys: SelectData[];
  oi?: any;
  sd?: any;
  open?: any;
  settings?: any;
  readyToSend: any;
  finace: any;
}

export default class KontoPage extends Basepage<KontoState, KontoModel> {
  renderChild(): JSX.Element {
    if (!this.state.hasApiData || this.state.apiData.isLogin == false) {
      return (
        <Route path={'/konto/'} exact={true}>
          <Redirect to="/" />
        </Route>
      );
    }

    return (
      <div id="konto">
        <div className="menuContaine">
          {this.state.apiData.mol_kunde != 0 ? (
            <>
              <div style={{ margin: '10px', textAlign: 'center' }}>
                <b>
                  Kundennummer:
                  <br />
                  {this.state.apiData.mol_kunde}
                </b>
              </div>
            </>
          ) : null}
          <MolLink to="/konto/settings" href="/konto/settings">
            Konto
          </MolLink>
          <MolLink to="/konto/address" href="/konto/address">
            Adressbuch
          </MolLink>
          <MolLink
            to="/konto/mol_orders"
            href="/konto/mol_orders"
            activStartWith={true}
          >
            Bestellungen
          </MolLink>
          <MolLink
            to="/konto/shipping"
            href="/konto/shipping"
            activStartWith={true}
          >
            Lieferungen
          </MolLink>
          <MolLink to="/konto/open" href="/konto/open" activStartWith={true}>
            Offene Positionen
          </MolLink>{' '}
          <MolLink to="/konto/readyToSend" href="/konto/readyToSend">
            Bereit zum Versand
          </MolLink>
          <MolLink to="/konto/finace" href="/konto/finace">
            Finanzen
          </MolLink>
          <div style={{ paddingLeft: '15px' }}>
            <MolLink
              to="/konto/finace/rechnungen"
              href="/konto/finace/rechnungen"
            >
              Rechnungen
            </MolLink>
            <MolLink
              to="/konto/finace/zahlungen"
              href="/konto/finace/zahlungen"
            >
              Zahlungen
            </MolLink>
            <MolLink to="/konto/finace/umsatze" href="/konto/finace/umsatze">
              Umsätze
            </MolLink>
            <MolLink to="/konto/finace/saldo" href="/konto/finace/saldo">
              Saldo
            </MolLink>
          </div>
          {/* readyToSend */}
        </div>
        <div className="container">
          <Switch>
            <Route path={'/konto/'} exact={true}>
              <Redirect to="/konto/settings" />
            </Route>
            <Route path={'/konto/settings'}>
              <Settings
                data={this.body.settings}
                apibase={this.state.apiBase}
              />
            </Route>
            <Route path={'/konto/address'} exact={true}>
              <AdressList list={this.body.addresse} />
            </Route>
            <Route path={'/konto/address/:id'}>
              {this.body.addresse?.length > 0 ? (
                <AddressEdit
                  data={this.body}
                  apiBase={this.state.apiBase}
                  userID={this.state.apiData.userID}
                />
              ) : null}
            </Route>
            <Route path={'/konto/'} exact={true}>
              <Redirect to="/konto/settings" />
            </Route>
            <Route path={'/konto/mol_orders'} exact={true}>
              <OrderList data={this.body} />
            </Route>
            <Route path={'/konto/mol_orders/:id'}>
              {this.body.oi != undefined ? (
                <OrderInfo_mol
                  data={this.body.oi}
                  apiBase={this.state.apiBase}
                />
              ) : null}
            </Route>
            <Route path={'/konto/shipping'} exact={true}>
              {this.body.shipping != undefined ? (
                <SchippingList list={this.body.shipping} />
              ) : null}
            </Route>
            <Route path={'/konto/shipping/:id'}>
              {this.body.sd != undefined ? (
                <SchippingDratails
                  data={this.body.sd}
                  apiBase={this.state.apiBase}
                />
              ) : null}
            </Route>
            <Route path={'/konto/open'}>
              {this.body.open != undefined ? (
                <OpenList data={this.body.open} apiBase={this.state.apiBase} />
              ) : null}
            </Route>
            <Route path={'/konto/readyToSend'}>
              {this.body.readyToSend != undefined ? (
                <ReadyToSend
                  data={this.body.readyToSend}
                  apiBase={this.state.apiBase}
                />
              ) : null}
            </Route>
            <Route path={'/konto/finace'} exact={true}>
              {this.body.finace != undefined ? (
                <>
                  {/*  <Finance data={this.body.finace} apiBase={this.state.apiBase} />*/}{' '}
                </>
              ) : null}
            </Route>
            <Route path={'/konto/finace/rechnungen'}>
              {this.body.finace != undefined ? (
                <Rechnungen
                  data={this.body.finace}
                  apiBase={this.state.apiBase}
                />
              ) : null}
            </Route>
            <Route path={'/konto/finace/zahlungen'}>
              {this.body.finace != undefined ? (
                <Zahlungen
                  data={this.body.finace}
                  apiBase={this.state.apiBase}
                />
              ) : null}
            </Route>
            <Route path={'/konto/finace/umsatze'}>
              {this.body.finace != undefined ? (
                <Umsatze data={this.body.finace} apiBase={this.state.apiBase} />
              ) : null}
            </Route>
            <Route path={'/konto/finace/saldo'}>
              {this.body.finace != undefined ? (
                <Saldoauszug
                  data={this.body.finace}
                  apiBase={this.state.apiBase}
                />
              ) : null}
            </Route>
          </Switch>
        </div>
      </div>
    );
  }
  initState(base: BasePageState): KontoState {
    let newState: KontoState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    let anyWin: any = window;
    let location = anyWin.historyHelper.memory.location;
    //'/konto/'.length => 7
    let module = location.pathname.substring(7);
    let search = '';

    if (location.search != '' && location.search.length > 1) {
      search = '&' + location.search.substring(1);
    }
    return this.state.apiBase + '/Account.php?module=' + module + search;
  }

  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'Konto';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Konto</span>;
  }
  getType(): string {
    return 'KontoPage';
  }
}
